
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Function to check if device is mobile
    const checkMobile = () => {
      // First approach: Use matchMedia (modern browsers)
      if (window.matchMedia) {
        return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
      }
      // Fallback: Check window width directly
      return window.innerWidth < MOBILE_BREAKPOINT
    }

    // Set initial value
    setIsMobile(checkMobile())

    // Add event listener for resize
    const handleResize = () => {
      setIsMobile(checkMobile())
    }

    // Using both approaches for maximum compatibility
    if (window.matchMedia) {
      const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
      
      // Use addEventListener with fallback to older browsers
      if (mql.addEventListener) {
        mql.addEventListener("change", handleResize)
      } else {
        // @ts-ignore - For older browsers that use the deprecated addListener
        mql.addListener && mql.addListener(handleResize)
      }
    }
    
    // Always add the resize listener as an additional fallback
    window.addEventListener("resize", handleResize)
    
    // Clean up
    return () => {
      if (window.matchMedia) {
        const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
        if (mql.removeEventListener) {
          mql.removeEventListener("change", handleResize)
        } else {
          // @ts-ignore - For older browsers
          mql.removeListener && mql.removeListener(handleResize)
        }
      }
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return !!isMobile
}
